import { useState } from "react";
import "@/App.css";
import { AccountBar } from "./components/auth/AccountBar";
import { AdminPage } from "./components/auth/AdminPage";
import { AuthPanel } from "./components/auth/AuthPanel";
import { ProfilePage } from "./components/auth/ProfilePage";
import { TraderPage } from "./components/auth/TraderPage";
import { ViewerSummaryPage } from "./components/auth/ViewerSummaryPage";
import { useDashboardData } from "./hooks/useDashboardData";
import { useBotAndRiskActions } from "./hooks/useBotAndRiskActions";
import { useCredentialAndLiveActions } from "./hooks/useCredentialAndLiveActions";
import { useOrderPlacement } from "./hooks/useOrderPlacement";
import { useSelectedTicker } from "./hooks/useSelectedTicker";
import { DashboardLayout } from "./components/trading/DashboardLayout";

function TradingDashboard() {
  const [session, setSession] = useState(null);
  const [activeView, setActiveView] = useState("dashboard");
  const { dashboard, loading, error, selectedSymbol, setSelectedSymbol, risk, setRisk, setDashboard, loadDashboard } = useDashboardData();
  const [mode, setMode] = useState("paper");
  const selectedTicker = useSelectedTicker(dashboard, selectedSymbol);
  const orderTools = useOrderPlacement({ mode, selectedSymbol, selectedTicker, loadDashboard });
  const { botBusy, toggleBot, saveRisk } = useBotAndRiskActions({
    dashboard, selectedSymbol, risk, setDashboard, loadDashboard, setOrderMessage: orderTools.setOrderMessage,
  });
  const credentialTools = useCredentialAndLiveActions({ dashboard, setDashboard, loadDashboard, setOrderMessage: orderTools.setOrderMessage });

  const onAuthenticated = (authData) => {
    setSession(authData);
  };

  const logout = () => {
    setSession(null);
    setActiveView("dashboard");
  };

  const updateSessionUser = (user) => {
    const next = { ...session, user };
    setSession(next);
  };

  if (!session) return <AuthPanel onAuthenticated={onAuthenticated} />;
  if (activeView === "profile") return <><AccountBar user={session.user} activeView={activeView} setActiveView={setActiveView} onLogout={logout} /><ProfilePage user={session.user} token={session.token} onProfileUpdated={updateSessionUser} /></>;
  if (activeView === "admin" && session.user.role === "admin") return <><AccountBar user={session.user} activeView={activeView} setActiveView={setActiveView} onLogout={logout} /><AdminPage token={session.token} /></>;
  if (loading) return <main className="terminal-shell loading" data-testid="dashboard-loading-state">Loading OKX control room…</main>;
  if (error) return <main className="terminal-shell error" data-testid="dashboard-error-message">{error}</main>;

  if (session.user.role === "viewer") {
    return <><AccountBar user={session.user} activeView={activeView} setActiveView={setActiveView} onLogout={logout} /><ViewerSummaryPage dashboard={dashboard} /></>;
  }

  if (session.user.role === "trader") {
    return <><AccountBar user={session.user} activeView={activeView} setActiveView={setActiveView} onLogout={logout} /><TraderPage {...{ dashboard, selectedSymbol, setSelectedSymbol, selectedTicker, risk, orderTools }} /></>;
  }

  return <><AccountBar user={session.user} activeView={activeView} setActiveView={setActiveView} onLogout={logout} /><DashboardLayout {...{ dashboard, mode, setMode, selectedSymbol, setSelectedSymbol, selectedTicker, risk, setRisk, botBusy, toggleBot, saveRisk, credentialTools, orderTools, loadDashboard }} /></>;
}

export default function App() {
  return <TradingDashboard />;
}
